import type { CreateConfigurationModuleV2MutationRequestApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { ConfigurationModuleResource } from '../../models/configurationModules.model';

export function mapConfigurationModuleUpdateResponse(
  response: CreateConfigurationModuleV2MutationRequestApi,
): ConfigurationModuleResource {
  return {
    id: '',
    name: response.name,
    parameterSets: response.parameterSets.map(({ values, templateId }) => ({ values, template: { id: templateId } })),
    softwareVersion: response.softwareVersion,
    description: response.description,
  } satisfies ConfigurationModuleResource;
}
